import React from "react";

export function PauseOverlay({
	onResume,
	onSettings,
	onQuit,
}: {
	onResume: () => void;
	onSettings: () => void;
	onQuit: () => void;
}) {
	return (
		<div className="pause-overlay">
			<div className="pause-menu pixel-panel pixel-frame">
				<h2>Paused</h2>
				<button className="btn-pixel btn-pixel--primary" onClick={onResume}>
					Resume
				</button>
				<button className="btn-pixel" onClick={onSettings}>
					Settings
				</button>
				<button className="btn-pixel btn-pixel--danger" onClick={onQuit}>
					Quit
				</button>
			</div>
		</div>
	);
}
